/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class MasterAccountBillingQueryConversations extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("MasterAccountBillingQueryConversations");
    }

    getFixupPrototypeFunction() { return MasterAccountBillingQueryConversations.fixupPrototype; }

    static newInstance(model: Partial<MasterAccountBillingQueryConversations>): MasterAccountBillingQueryConversations {
        let obj = Object.assign(new MasterAccountBillingQueryConversations(), model);
        MasterAccountBillingQueryConversations.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<MasterAccountBillingQueryConversations>): MasterAccountBillingQueryConversations {
        if (!model) return null;
        return MasterAccountBillingQueryConversations.newInstance(<MasterAccountBillingQueryConversations> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: MasterAccountBillingQueryConversations) {
        if (!obj) return;

        models.MasterAccountBillingQueryConversations.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: MasterAccountBillingQueryConversations): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, MasterAccountBillingQueryConversations.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * ID of conversations
     */
    conversation_ids: Array<string>;

}
